import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  TrackByFunction,
} from '@angular/core';
import { IconComponent } from '@rivet-health/design-system';
import { concat, Observable, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';
import { ToastService, ToastType } from './toast.service';

interface ToastData {
  message?: string;
  icon?: IconComponent.Name;
  template?: TemplateRef<{}>;
  type?: ToastType;
  leave: boolean;
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'toast-outlet',
  styleUrls: ['./toast-outlet.component.scss'],
  templateUrl: './toast-outlet.component.html',
})
export class ToastOutletComponent {
  readonly toasts: Observable<ToastData[]> = this.toastService.toast.pipe(
    switchMap(toast =>
      concat(
        of([
          {
            message: toast.message,
            icon: toast.icon,
            template: toast.template,
            type: toast.type,
            leave: false,
          },
        ]),
        of([
          {
            message: toast.message,
            icon: toast.icon,
            template: toast.template,
            type: toast.type,
            leave: true,
          },
        ]).pipe(delay(toast.duration)),
        of([]).pipe(delay(toast.duration + 300)),
      ),
    ),
  );

  constructor(readonly toastService: ToastService) {}

  trackBy: TrackByFunction<ToastData> = (_, toast) => toast.template;
}
